// NPM
import React from "react"
import _ from "lodash"

const Dropdown = ({ formField, value, required, onChange }) => {
  if (!formField) {
    return null
  }

  return (
    <div className="Dropdown field">
      <label className="label">{formField.name}</label>
      <div className="control">
        <div className="select">
          <select
            value={value}
            onChange={e => onChange(e.target.value)}
            required={required}
          >
            {formField.placeholder && (
              <option disabled value="">
                {formField.placeholder}
              </option>
            )}
            {_.get(formField, "options", []).map((option, optionIndex) => {
              return (
                <option
                  key={`Option-${optionIndex}`}
                  value={option.value}
                  hidden={option.value == ""}
                >
                  {option.label}
                </option>
              )
            })}
          </select>
        </div>
      </div>
    </div>
  )
}

export default Dropdown
